import React, { useState, useEffect } from "react";
import getApiBaseUrl from "../config/api";
import { apiCall } from "../config/api";

import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Alert,
  CircularProgress,
  Paper,
  Snackbar,
  Autocomplete,
  Avatar,
} from "@mui/material";
import Slider from "@mui/material/Slider";
import { AudioPicker } from "./AudioLibraryPage";
import Divider from "@mui/material/Divider";
import {
  Search as SearchIcon,
  CloudUpload as CloudUploadIcon,
  Map as MapIcon,
  Check as CheckIcon,
} from "@mui/icons-material";

const BulkPinCreationPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [location, setLocation] = useState("Ankara, Turkey"); // Default location
  const [searchResults, setSearchResults] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [campaignName, setCampaignName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  // CSV verisi ve ön izleme
  const [csvRows, setCsvRows] = useState([]);
  const [csvPreview, setCsvPreview] = useState({
    total: 0,
    valid: 0,
    invalid: 0,
    invalidRows: [],
  });
  const [csvFileName, setCsvFileName] = useState("");
  const [campaignUsers, setCampaignUsers] = useState([]);
  const [selectedCampaignUser, setSelectedCampaignUser] = useState(null);
  const [userFetchError, setUserFetchError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      setUserFetchError(null);
      try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          throw new Error("Oturum bulunamadı. Lütfen tekrar giriş yapın.");
        }
        const idToken = await currentUser.getIdToken();

        const response = await apiCall(`/api/admin/users`, {
          method: "GET",
          headers: { Authorization: `Bearer ${idToken}` },
        });

        console.log("API Response for users:", response);
        const rawUsers = response.users || [];

        // 1. Kullanıcıları benzersiz ve eksiksiz filtrele
        const seenEmails = new Set();
        const usersList = rawUsers
          .map((user) => ({
            id: user.id,
            name: user.displayName,
            photoUrl: user.photoURL,
            email: user.email,
          }))
          .filter((user) => {
            // Eksik bilgi varsa çıkar
            if (!user.name || !user.email) return false;
            // Aynı e-posta bir kez gösterilsin
            if (seenEmails.has(user.email)) return false;
            seenEmails.add(user.email);
            return true;
          });
        // 2. "Yeni Kullanıcı Oluştur" opsiyonunu ekle
        usersList.push({
          id: "new_user",
          name: "Yeni Kullanıcı Oluştur",
          email: "",
          photoUrl: "",
        });
        setCampaignUsers(usersList);
      } catch (err) {
        console.error("Kullanıcılar getirilirken hata oluştu:", err);
        const errorMessage = err.response?.data?.error || err.message;
        setUserFetchError(errorMessage);
        setCampaignUsers([]);
      }
    };
    fetchUsers();
  }, []);

  const [pinTemplate, setPinTemplate] = useState({
    textContent: "",
    category: "Standard",
    duration: "1_day",
    audioFile: null,
    audioUrl: "",
    imageUrl: "",
    pinOwnerName: "",
    pinOwnerPhotoUrl: "",
    marker: { type: "profile", size: "medium" },
  });
  const [batchProgress, setBatchProgress] = useState({
    isProcessing: false,
    total: 0,
    completed: 0,
    successful: 0,
    failed: 0,
    errors: [],
  });
  const [successSnackbar, setSuccessSnackbar] = useState(false);

  const categories = ["Standard", "Event", "Promotion", "Warning"];
  const durationOptions = [
    { value: "1_hour", label: "1 Saat" },
    { value: "6_hours", label: "6 Saat" },
    { value: "12_hours", label: "12 Saat" },
    { value: "1_day", label: "1 Gün" },
    { value: "3_days", label: "3 Gün" },
    { value: "1_week", label: "1 Hafta" },
    { value: "1_month", label: "1 Ay" },
  ];

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoUrl(""); // Clear URL field when a file is selected
    }
  };

  // CSV örnek indir
  const downloadSampleCsv = () => {
    const headers = ["name", "address", "lat", "lng"];
    const sample = [
      headers.join(","),
      'Starbucks Tunalı,"Remzi Oğuz Arık, Tunalı Hilmi Cd. No:119/A, Çankaya/Ankara",39.90338,32.86056',
      'Starbucks Kızılay,"Kızılay AVM, Gazi Mustafa Kemal Blv. No:96, Çankaya/Ankara",39.93336,32.85974',
    ].join("\n");
    const blob = new Blob([sample], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "pin_template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  // CSV ayrıştırma (basit)
  const parseCsvText = (text) => {
    const lines = text.split(/\r?\n/).filter((l) => l.trim().length > 0);
    if (lines.length === 0)
      return {
        rows: [],
        preview: { total: 0, valid: 0, invalid: 0, invalidRows: [] },
      };
    let startIdx = 0;
    const header = lines[0].toLowerCase();
    if (
      header.includes("name") &&
      header.includes("lat") &&
      header.includes("lng")
    )
      startIdx = 1;
    const rows = [];
    const invalidRows = [];
    for (let i = startIdx; i < lines.length; i++) {
      const raw = lines[i];
      const cols = [];
      let cur = "";
      let inQuotes = false;
      for (let c = 0; c < raw.length; c++) {
        const ch = raw[c];
        if (ch === '"') {
          inQuotes = !inQuotes;
          continue;
        }
        if (ch === "," && !inQuotes) {
          cols.push(cur.trim());
          cur = "";
        } else {
          cur += ch;
        }
      }
      cols.push(cur.trim());
      const [name, address, latStr, lngStr] = cols;
      const lat = parseFloat(latStr);
      const lng = parseFloat(lngStr);
      const ok =
        name &&
        address &&
        typeof lat === "number" &&
        !isNaN(lat) &&
        typeof lng === "number" &&
        !isNaN(lng);
      if (!ok) {
        invalidRows.push({ line: i + 1, raw });
        continue;
      }
      rows.push({
        id: `csv-${i}`,
        name,
        formatted_address: address,
        geometry: {
          location: {
            lat: Number(lat.toFixed(5)),
            lng: Number(lng.toFixed(5)),
          },
        },
        lat: Number(lat.toFixed(5)),
        lng: Number(lng.toFixed(5)),
        status: "Tam",
      });
    }
    return {
      rows,
      preview: {
        total: lines.length - startIdx,
        valid: rows.length,
        invalid: invalidRows.length,
        invalidRows,
      },
    };
  };

  const handleCsvUpload = (file) => {
    if (!file) return;
    setCsvFileName(file.name);
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = reader.result.toString();
        const { rows, preview } = parseCsvText(text);
        setCsvRows(rows);
        setCsvPreview(preview);
      } catch (e) {
        setCsvRows([]);
        setCsvPreview({ total: 0, valid: 0, invalid: 0, invalidRows: [] });
      }
    };
    reader.readAsText(file, "utf-8");
  };

  // Seçili konumları CSV indir
  const downloadSelectedCsv = (rows, fileName = "selected_pins.csv") => {
    if (!rows || rows.length === 0) return;
    const headers = ["name", "address", "lat", "lng"];
    const lines = [headers.join(",")];
    rows.forEach((r) => {
      const name = (r.name || "").replaceAll('"', '""');
      const addr = (r.formatted_address || "").replaceAll('"', '""');
      const lat = (r.lat ?? r.geometry?.location?.lat ?? "").toString();
      const lng = (r.lng ?? r.geometry?.location?.lng ?? "").toString();
      lines.push(`"${name}","${addr}",${lat},${lng}`);
    });
    const blob = new Blob([lines.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleLogoUrlChange = (event) => {
    const url = event.target.value;
    setLogoUrl(url);
    if (url) {
      setLogoFile(null); // Clear file input when URL is typed
    }
  };

  const handleSearch = async () => {
    const q = searchQuery.trim();
    const loc = location.trim();
    if (!q || !loc) {
      setSearchResults([]);
      return;
    }
    setLoading(true);
    try {
      // Try GET first (Cloud Functions in some deploys uses GET)
      const response = await apiCall(`/api/places/search`, {
        method: "POST",
        body: JSON.stringify({ query: q, locationText: loc }),
      });
      // Koordinat normalizasyon fonksiyonu
      function normalizeCoord(val) {
        if (typeof val === "string") val = Number(val);
        if (Array.isArray(val)) val = Number(val[0]);
        if (typeof val !== "number" || isNaN(val)) return null;
        // Virgülden sonra 5 basamak
        return Number(val.toFixed(5));
      }
      const places = Array.isArray(response.places) ? response.places : [];
      const preparedResults = places.map((place, index) => {
        let lat = place.geometry?.location?.lat ?? place.lat ?? place.latitude;
        let lng = place.geometry?.location?.lng ?? place.lng ?? place.longitude;
        lat = normalizeCoord(lat);
        lng = normalizeCoord(lng);
        return {
          id: place.place_id || index,
          ...place,
          geometry: {
            ...place.geometry,
            location: { lat, lng },
          },
          lat,
          lng,
          status: place.formatted_address ? "Tam" : "Adres Eksik",
        };
      });
      setSearchResults(preparedResults);
      setSelectedLocations([]);
    } catch (error) {
      console.error("Search failed:", error);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelectedLocations(searchResults);
      return;
    }
    setSelectedLocations([]);
  };

  const handleCheckboxClick = (event, item) => {
    const selectedIndex = selectedLocations.findIndex((l) => l.id === item.id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedLocations, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedLocations.slice(1));
    } else if (selectedIndex === selectedLocations.length - 1) {
      newSelected = newSelected.concat(selectedLocations.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedLocations.slice(0, selectedIndex),
        selectedLocations.slice(selectedIndex + 1)
      );
    }
    setSelectedLocations(newSelected);
  };

  const handleTemplateChange = (field, value) => {
    setPinTemplate((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const createBulkPins = async () => {
    // 1. Validate inputs
    if (!campaignName.trim()) {
      alert("Lütfen bir kampanya adı girin.");
      return;
    }

    let locationsToCreate = [];
    if (activeTab === 0) {
      locationsToCreate = selectedLocations;
    } else if (activeTab === 1) {
      locationsToCreate = csvRows;
    }

    if (locationsToCreate.length === 0) {
      alert("Lütfen en az bir konum seçin veya CSV dosyası yükleyin.");
      return;
    }

    setBatchProgress({
      isProcessing: true,
      total: locationsToCreate.length,
      completed: 0,
      successful: 0,
      failed: 0,
      errors: [],
    });

    // Yerel sayaçlar: try/catch dışında tanımla ki fonksiyon sonunda erişilebilir olsun
    let successfulCount = 0;
    let failedCount = 0;
    let completedCount = 0;

    try {
      // Oturum ve token (kampanya ve pin istekleri için kullanacağız)
      const currentUser = auth.currentUser;
      if (!currentUser)
        throw new Error("Oturum bulunamadı. Lütfen tekrar giriş yapın.");
      const idToken = await currentUser.getIdToken();

      // 2. Create the campaign first
      setSuccessSnackbar(false);
      let campaignResponse;
      if (logoFile) {
        const campaignFormData = new FormData();
        campaignFormData.append("name", campaignName);
        campaignFormData.append("logoFile", logoFile);
        // Content-Type'ı axios kendi sınırı ile ayarlasın (boundary sorunu yaşamamak için)
        // apiCall FormData'yı doğrudan desteklemiyor, bu nedenle fetch'i manuel olarak kullanıyoruz
        // Ancak URL'i merkezi yapılandırmadan alıyoruz.
        const campaignApiUrl = `${getApiBaseUrl()}/campaigns`;
        campaignResponse = await fetch(campaignApiUrl, {
          method: "POST",
          body: campaignFormData,
          headers: { Authorization: `Bearer ${idToken}` }, // Content-Type'ı tarayıcı belirlesin
        }).then((res) => res.json());
        campaignResponse = { data: campaignResponse }; // axios formatına benzetmek için
      } else {
        // Dosya yoksa JSON gönder (backend JSON'u destekliyor)
        campaignResponse = await apiCall(`/api/campaigns`, {
          method: "POST",
          body: JSON.stringify({
            name: campaignName,
            ...(logoUrl ? { logoUrl } : {}),
          }),
          headers: { Authorization: `Bearer ${idToken}` },
        });
        campaignResponse = { data: campaignResponse }; // axios formatına benzetmek için
      }

      if (!campaignResponse.data.success) {
        throw new Error(
          campaignResponse.data.error || "Kampanya oluşturulamadı."
        );
      }

      const newCampaignId = campaignResponse.data.campaign.id;

      // 3. Create pins for the new campaign via backend (secure, admin-only)
      const collectedErrors = [];
      for (const location of locationsToCreate) {
        console.log("[DEBUG] Pin ekleme başlıyor:", location);

        try {
          if (!location.geometry || !location.geometry.location) {
            console.warn(
              `Skipping pin for ${location.name} due to missing location data.`
            );
            failedCount += 1;
            collectedErrors.push(
              `Pin for ${location.name}: Konum bilgisi eksik.`
            );
            setBatchProgress({
              isProcessing: true,
              total: locationsToCreate.length,
              completed: completedCount,
              successful: successfulCount,
              failed: failedCount,
              errors: collectedErrors.slice(),
            });
            continue;
          }
          // --- Ara katman: koordinat normalize ve GeoPoint'e çevir ---
          // Koordinatları kesinlikle float'a çevir ve tip kontrolü yap
          let latitude =
            location.geometry?.location?.lat ??
            location.lat ??
            location.latitude;
          let longitude =
            location.geometry?.location?.lng ??
            location.lng ??
            location.longitude;
          latitude = parseFloat(latitude);
          longitude = parseFloat(longitude);
          if (
            typeof latitude !== "number" ||
            isNaN(latitude) ||
            typeof longitude !== "number" ||
            isNaN(longitude)
          ) {
            failedCount += 1;
            collectedErrors.push(
              `Pin için geçersiz koordinat formatı: ${location.name}`
            );
            setBatchProgress({
              isProcessing: true,
              total: locationsToCreate.length,
              completed: completedCount,
              successful: successfulCount,
              failed: failedCount,
              errors: collectedErrors.slice(),
            });
            continue;
          }
          try {
            // JSON veya multipart (audio varsa)
            let resp;
            if (pinTemplate.audioFile) {
              const form = new FormData();
              form.append("campaignId", newCampaignId);
              form.append("name", location.name);
              form.append("address", location.formatted_address || "");
              form.append("latitude", String(latitude));
              form.append("longitude", String(longitude));
              form.append("textContent", pinTemplate.textContent || "");
              form.append("category", pinTemplate.category || "Standard");
              form.append("duration", pinTemplate.duration || "1_day");
              form.append("pinOwnerName", pinTemplate.pinOwnerName || "");
              form.append(
                "pinOwnerPhotoUrl",
                pinTemplate.pinOwnerPhotoUrl || ""
              );
              form.append(
                "userProfileImageUrl",
                pinTemplate.userProfileImageUrl || ""
              );
              form.append("marker", JSON.stringify(pinTemplate.marker || {}));
              form.append("audio", pinTemplate.audioFile);
              const pinsApiUrl = `${getApiBaseUrl()}/pins`;
              resp = await fetch(pinsApiUrl, {
                method: "POST",
                body: form,
                headers: { Authorization: `Bearer ${idToken}` },
              }).then((res) => res.json());
              resp = { data: resp }; // axios formatına benzetmek için
            } else {
              resp = await apiCall(`/api/pins`, {
                method: "POST",
                body: JSON.stringify({
                  campaignId: newCampaignId,
                  name: location.name,
                  address: location.formatted_address,
                  latitude,
                  longitude,
                  textContent: pinTemplate.textContent,
                  category: pinTemplate.category,
                  duration: pinTemplate.duration,
                  pinOwnerName: pinTemplate.pinOwnerName,
                  pinOwnerPhotoUrl: pinTemplate.pinOwnerPhotoUrl,
                  userProfileImageUrl: pinTemplate.userProfileImageUrl,
                  marker: pinTemplate.marker,
                  ...(pinTemplate.audioUrl
                    ? { audioUrl: pinTemplate.audioUrl }
                    : {}),
                  ...(pinTemplate.imageUrl
                    ? { imageUrl: pinTemplate.imageUrl }
                    : {}),
                }),
                headers: { Authorization: `Bearer ${idToken}` },
              });
              resp = { data: resp }; // axios formatına benzetmek için
            }
            if (resp.data?.success) {
              successfulCount += 1;
              setBatchProgress({
                isProcessing: true,
                total: locationsToCreate.length,
                completed: completedCount,
                successful: successfulCount,
                failed: failedCount,
                errors: collectedErrors.slice(),
              });
            } else {
              throw new Error(resp.data?.error || "Pin oluşturulamadı");
            }
          } catch (backendError) {
            console.error(
              "[ERROR] Backend pin oluşturma hatası:",
              backendError
            );
            failedCount += 1;
            const apiErrorMsg =
              backendError?.response?.data?.error ||
              backendError?.response?.data?.message ||
              backendError.message ||
              "Bilinmeyen hata";
            collectedErrors.push(
              `Backend pin oluşturma hatası: ${location.name} - ${apiErrorMsg}`
            );
            setBatchProgress({
              isProcessing: true,
              total: locationsToCreate.length,
              completed: completedCount,
              successful: successfulCount,
              failed: failedCount,
              errors: collectedErrors.slice(),
            });
            continue;
          }
        } catch (error) {
          console.error(`Failed to create pin for ${location.name}:`, error);
          failedCount += 1;
          const apiErrorMsg =
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error.message ||
            "Bilinmeyen hata";
          collectedErrors.push(`Pin for ${location.name}: ${apiErrorMsg}`);
          setBatchProgress({
            isProcessing: true,
            total: locationsToCreate.length,
            completed: completedCount,
            successful: successfulCount,
            failed: failedCount,
            errors: collectedErrors.slice(),
          });
        } finally {
          completedCount += 1;
          setBatchProgress({
            isProcessing: true,
            total: locationsToCreate.length,
            completed: completedCount,
            successful: successfulCount,
            failed: failedCount,
            errors: collectedErrors.slice(),
          });
        }
      }
    } catch (campaignError) {
      console.error("Failed to create campaign:", campaignError);
      alert(`Kampanya oluşturulamadı: ${campaignError.message}`);
      setBatchProgress({
        isProcessing: false,
        total: 0,
        completed: 0,
        successful: 0,
        failed: 0,
        errors: [],
      });
      return;
    }

    // İşlem tamamlandı -> state'i kapat ve sonucu yerel sayaçlara göre değerlendir
    setBatchProgress((prev) => ({ ...prev, isProcessing: false }));
    // Not: successfulCount/failedCount local sayaçları burada görülebilir
    // success snackbar: tümü başarılıysa göster
    // Scroll: hata varsa kullanıcıya listeyi göster
    // (local sayaçlar, üstte tanımlı scope'ta)
    // eslint-disable-next-line no-undef
    if (
      typeof successfulCount !== "undefined" &&
      typeof failedCount !== "undefined"
    ) {
      if (successfulCount > 0 && failedCount === 0) {
        setSuccessSnackbar(true);
      } else if (failedCount > 0) {
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          });
        }, 500);
      }
    }
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 5, boxShadow: 8, background: "#fff" }}>
      <Typography variant="h4" gutterBottom>
        Yeni Kampanya ve Pinleri Oluştur
      </Typography>
      {userFetchError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Kullanıcı listesi yüklenemedi: {userFetchError}
        </Alert>
      )}
      <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            required
            label="Yeni Kampanya Adı"
            value={campaignName}
            onChange={(e) => setCampaignName(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Logo URL'i (Opsiyonel)"
            value={logoUrl}
            onChange={handleLogoUrlChange}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={2}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <Button variant="outlined" component="label" sx={{ mr: 1 }}>
            Dosya Seç
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
          </Button>
          {logoFile && (
            <Typography variant="caption" noWrap maxWidth={160}>
              {logoFile.name}
            </Typography>
          )}
        </Grid>
        {/* Kampanya kullanıcısı ayrı satıra taşındı */}
      </Grid>
      <Grid container spacing={2} sx={{ mb: 2 }} alignItems="center">
        {/* eski Dosya Seç satırı kaldırıldı */}
      </Grid>
      <Divider sx={{ my: 2 }} />
      {/* Kampanya Kullanıcısı: tam genişlik, Pin Metni'nin üstünde */}
      <Box sx={{ mb: 2 }}>
        <Autocomplete
          options={campaignUsers}
          getOptionLabel={(option) =>
            option.name ? `${option.name} (${option.email})` : ""
          }
          renderOption={(props, option) => (
            <Box
              component="li"
              {...props}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Avatar
                src={option.photoUrl}
                sx={{ width: 32, height: 32, mr: 1 }}
              />
              <Box>
                <Typography variant="body1" fontWeight={600}>
                  {option.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.email}
                </Typography>
              </Box>
            </Box>
          )}
          value={selectedCampaignUser}
          onChange={(_, value) => {
            if (value && value.id === "new_user") {
              navigate("/user-management?add=true", { replace: true });
            } else {
              setSelectedCampaignUser(value);
              setPinTemplate((prev) => ({
                ...prev,
                pinOwnerName: value?.name || "",
                pinOwnerPhotoUrl: value?.photoUrl || "",
                userProfileImageUrl: value?.photoUrl || "",
              }));
            }
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          noOptionsText={<span>Hiç kullanıcı yok</span>}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kampanya Kullanıcısı"
              fullWidth
              InputProps={{ ...params.InputProps, sx: { borderRadius: 3 } }}
            />
          )}
          sx={{ width: "100%" }}
        />
      </Box>
      {/* Pin Metni alanını üst tarafa al */}
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Pin Metni"
          value={pinTemplate.textContent}
          onChange={(e) => handleTemplateChange("textContent", e.target.value)}
          fullWidth
          InputProps={{ sx: { borderRadius: 3, fontSize: 16 } }}
        />
      </Box>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={6}>
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant="fullWidth"
          >
            <Tab label="Google Haritalar Arama" icon={<SearchIcon />} />
            <Tab label="CSV Dosyası Yükle" icon={<CloudUploadIcon />} />
            <Tab label="Harita Üzerinden Seçim" icon={<MapIcon />} disabled />
          </Tabs>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              justifyContent: "flex-end",
            }}
          ></Box>
        </Grid>
      </Grid>
      {activeTab === 0 && (
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <Box>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Aranacak Yer (Örn: Starbucks)"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label="Konum (Örn: İzmir, Turkey)"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    disabled={
                      loading || !searchQuery.trim() || !location.trim()
                    }
                    fullWidth
                    startIcon={<SearchIcon />}
                  >
                    {loading ? <CircularProgress size={24} /> : "Ara"}
                  </Button>
                </Grid>
              </Grid>
              {loading && <LinearProgress sx={{ mt: 2 }} />}
              {searchResults.length > 0 && (
                <>
                  <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() =>
                        setSelectedLocations(
                          searchResults.filter((r) => r.status === "Tam")
                        )
                      }
                    >
                      Sadece Tam adresleri seç
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => setSelectedLocations(searchResults)}
                    >
                      Hepsini seç
                    </Button>
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => setSelectedLocations([])}
                    >
                      Seçimi temizle
                    </Button>
                  </Box>
                  <Box sx={{ mt: 2, textAlign: "center" }}>
                    <Typography variant="subtitle1" color="primary">
                      {searchResults.length} sonuç bulundu
                    </Typography>
                    <Box
                      sx={{
                        mt: 1,
                        display: "flex",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          downloadSelectedCsv(
                            searchResults,
                            "search_results.csv"
                          )
                        }
                      >
                        Sonuçları CSV indir
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          downloadSelectedCsv(
                            selectedLocations,
                            "selected_pins.csv"
                          )
                        }
                        disabled={selectedLocations.length === 0}
                      >
                        Seçilenleri CSV indir
                      </Button>
                    </Box>
                  </Box>
                  <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell padding="checkbox">
                            <Checkbox
                              indeterminate={
                                selectedLocations.length > 0 &&
                                selectedLocations.length < searchResults.length
                              }
                              checked={
                                searchResults.length > 0 &&
                                selectedLocations.length ===
                                  searchResults.length
                              }
                              onChange={handleSelectAllClick}
                              inputProps={{
                                "aria-label": "select all results",
                              }}
                            />
                          </TableCell>
                          <TableCell>Adı</TableCell>
                          <TableCell>Adres</TableCell>
                          <TableCell>Koordinatlar</TableCell>
                          <TableCell>Marker</TableCell>
                          <TableCell>Durum</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {searchResults.map((row) => {
                          const isItemSelected = selectedLocations.some(
                            (l) => l.id === row.id
                          );
                          return (
                            <TableRow
                              hover
                              key={row.id}
                              selected={isItemSelected}
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(event) =>
                                    handleCheckboxClick(event, row)
                                  }
                                />
                              </TableCell>
                              <TableCell>{row.name}</TableCell>
                              <TableCell>{row.formatted_address}</TableCell>
                              <TableCell>
                                {row.geometry && row.geometry.location
                                  ? `${row.geometry.location.lat}, ${row.geometry.location.lng}`
                                  : "-"}
                              </TableCell>
                              <TableCell sx={{ textAlign: "center" }}>
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  {logoUrl || logoFile ? (
                                    <img
                                      src={
                                        logoUrl ||
                                        (logoFile
                                          ? URL.createObjectURL(logoFile)
                                          : null)
                                      }
                                      alt="Kampanya Logosu"
                                      style={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                        border: "1px solid #1976d2",
                                      }}
                                    />
                                  ) : (
                                    <Box
                                      sx={{
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        backgroundColor: "#1976d2",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        fontSize: "10px",
                                      }}
                                    >
                                      📍
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                              <TableCell>{row.status}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}></Grid>
        </Grid>
      )}
      {activeTab === 1 && (
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <Button variant="outlined" onClick={downloadSampleCsv}>
              Örnek CSV indir
            </Button>
            <Button variant="contained" component="label">
              CSV Seç
              <input
                type="file"
                accept=".csv,text/csv"
                hidden
                onChange={(e) => handleCsvUpload(e.target.files[0])}
              />
            </Button>
            {csvFileName && (
              <Typography variant="body2">Seçilen: {csvFileName}</Typography>
            )}
          </Box>
          {csvPreview.total > 0 && (
            <Paper sx={{ mt: 2, p: 2 }}>
              <Typography variant="subtitle2">Ön izleme</Typography>
              <Typography variant="body2">
                Toplam: {csvPreview.total} | Geçerli: {csvPreview.valid} |
                Hatalı: {csvPreview.invalid}
              </Typography>
              <Table size="small" sx={{ mt: 1 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>Ad</TableCell>
                    <TableCell>Adres</TableCell>
                    <TableCell>Koordinatlar</TableCell>
                    <TableCell>Marker</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {csvRows.slice(0, 5).map((r) => (
                    <TableRow key={r.id}>
                      <TableCell>{r.name}</TableCell>
                      <TableCell>{r.formatted_address}</TableCell>
                      <TableCell>
                        {r.lat}, {r.lng}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {logoUrl || logoFile ? (
                            <img
                              src={
                                logoUrl ||
                                (logoFile
                                  ? URL.createObjectURL(logoFile)
                                  : null)
                              }
                              alt="Kampanya Logosu"
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                objectFit: "cover",
                                border: "1px solid #1976d2",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "#1976d2",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "white",
                                fontSize: "10px",
                              }}
                            >
                              📍
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )}
        </Box>
      )}
      <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap", mt: 2 }}>
        <FormControl sx={{ minWidth: 140 }} size="small">
          <InputLabel>Kategori</InputLabel>
          <Select
            value={pinTemplate.category}
            label="Kategori"
            onChange={(e) => handleTemplateChange("category", e.target.value)}
            sx={{ borderRadius: 3 }}
          >
            {categories.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 140 }} size="small">
          <InputLabel>Süre</InputLabel>
          <Select
            value={pinTemplate.duration}
            label="Süre"
            onChange={(e) => handleTemplateChange("duration", e.target.value)}
            sx={{ borderRadius: 3 }}
          >
            {durationOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* Marker Ayarları */}
        <FormControl sx={{ minWidth: 160 }} size="small">
          <InputLabel>Marker Türü</InputLabel>
          <Select
            value={pinTemplate.marker?.type || "profile"}
            label="Marker Türü"
            onChange={(e) =>
              setPinTemplate((prev) => ({
                ...prev,
                marker: { ...(prev.marker || {}), type: e.target.value },
              }))
            }
            sx={{ borderRadius: 3 }}
          >
            <MenuItem value="profile">Profil Fotoğrafı</MenuItem>
            <MenuItem value="dot">Kırmızı Nokta</MenuItem>
            <MenuItem value="music">Müzik Notası</MenuItem>
            <MenuItem value="letter">Harf</MenuItem>
            <MenuItem value="custom">Özel Görsel (URL)</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 140 }} size="small">
          <InputLabel>Boyut</InputLabel>
          <Select
            value={pinTemplate.marker?.size || "medium"}
            label="Boyut"
            onChange={(e) =>
              setPinTemplate((prev) => ({
                ...prev,
                marker: { ...(prev.marker || {}), size: e.target.value },
              }))
            }
            sx={{ borderRadius: 3 }}
          >
            <MenuItem value="tiny">Çok Küçük</MenuItem>
            <MenuItem value="small">Küçük</MenuItem>
            <MenuItem value="medium">Orta</MenuItem>
            <MenuItem value="large">Büyük</MenuItem>
          </Select>
        </FormControl>
        {pinTemplate.marker?.type === "dot" && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 24,
                height: 24,
                borderRadius: "50%",
                border: "1px solid #ddd",
                background: pinTemplate.marker?.color || "#ff2d55",
              }}
              title="Seçilen renk"
            />
            <input
              type="color"
              value={pinTemplate.marker?.color || "#ff2d55"}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  marker: { ...(prev.marker || {}), color: e.target.value },
                }))
              }
              style={{
                width: 40,
                height: 36,
                border: "1px solid #ddd",
                borderRadius: 6,
                background: "transparent",
              }}
            />
            <TextField
              label="Renk (#rrggbb)"
              value={pinTemplate.marker?.color || "#ff2d55"}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  marker: { ...(prev.marker || {}), color: e.target.value },
                }))
              }
              size="small"
              sx={{ minWidth: 180 }}
            />
          </Box>
        )}
        {pinTemplate.marker?.type === "letter" && (
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              label="Harf"
              inputProps={{ maxLength: 1 }}
              value={pinTemplate.marker?.letter || "A"}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  marker: {
                    ...(prev.marker || {}),
                    letter: (e.target.value || "A").toUpperCase().slice(0, 1),
                  },
                }))
              }
              size="small"
              sx={{ width: 100 }}
            />
            <TextField
              label="Renk (#rrggbb)"
              value={pinTemplate.marker?.color || "#ff2d55"}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  marker: { ...(prev.marker || {}), color: e.target.value },
                }))
              }
              size="small"
              sx={{ minWidth: 180 }}
            />
          </Box>
        )}
        {pinTemplate.marker?.type === "custom" && (
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 1, flex: 1 }}
          >
            <TextField
              fullWidth
              label="Özel ikon URL"
              value={pinTemplate.marker?.iconUrl || ""}
              onChange={(e) =>
                setPinTemplate((prev) => ({
                  ...prev,
                  marker: { ...(prev.marker || {}), iconUrl: e.target.value },
                }))
              }
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
                İkon Ölçek
              </Typography>
              <Slider
                sx={{ width: 220 }}
                value={
                  typeof pinTemplate.marker?.iconScale === "number"
                    ? pinTemplate.marker.iconScale
                    : 1
                }
                min={0.6}
                max={1.4}
                step={0.05}
                onChange={(_, v) =>
                  setPinTemplate((prev) => ({
                    ...prev,
                    marker: {
                      ...(prev.marker || {}),
                      iconScale: Array.isArray(v) ? v[0] : v,
                    },
                  }))
                }
              />
              <Typography variant="caption">
                {(pinTemplate.marker?.iconScale ?? 1).toFixed(2)}x
              </Typography>
            </Box>
          </Box>
        )}
        {/* Ses dosyası seçenekleri: Kütüphaneden URL veya Dosya Yükle (beta) */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <AudioPicker
            value={pinTemplate.audioUrl}
            onChange={(url) =>
              setPinTemplate((prev) => ({ ...prev, audioUrl: url }))
            }
          />
        </Box>

        {/* Resim URL alanı */}
        <Box sx={{ mt: 3 }}>
          <TextField
            fullWidth
            label="Resim URL (Opsiyonel)"
            variant="outlined"
            value={pinTemplate.imageUrl}
            onChange={(e) =>
              setPinTemplate((prev) => ({
                ...prev,
                imageUrl: e.target.value,
              }))
            }
            placeholder="https://example.com/image.jpg"
            helperText="Pin'lere eklenecek resim URL'sini girin"
          />
        </Box>
      </Box>
      {/* Alttaki kopya kampanya kullanıcı alanı kaldırıldı */}
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{
            borderRadius: 4,
            px: 6,
            py: 2,
            fontWeight: 700,
            fontSize: 20,
            boxShadow: 4,
          }}
          startIcon={
            batchProgress.isProcessing ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              <CheckIcon />
            )
          }
          disabled={
            batchProgress.isProcessing ||
            successSnackbar ||
            !selectedCampaignUser ||
            !campaignName.trim() ||
            (activeTab === 0
              ? selectedLocations.length === 0
              : csvRows.length === 0)
          }
          onClick={createBulkPins}
        >
          Toplu Pin Oluştur
        </Button>
        {/* Her zaman hata mesajlarını göster */}
        {batchProgress.errors.length > 0 && (
          <Box sx={{ width: "100%", mt: 3 }}>
            {batchProgress.errors.map((err, idx) => (
              <Alert severity="error" key={idx} sx={{ mb: 1, borderRadius: 2 }}>
                {err}
              </Alert>
            ))}
          </Box>
        )}
        {batchProgress.isProcessing && (
          <Box sx={{ width: "100%", mt: 3 }}>
            <LinearProgress
              variant="determinate"
              value={
                batchProgress.total > 0
                  ? (batchProgress.completed / batchProgress.total) * 100
                  : 0
              }
              sx={{ height: 8, borderRadius: 4 }}
            />
            <Typography variant="body2" sx={{ mt: 1 }}>
              {`İşlemde: ${batchProgress.completed}/${batchProgress.total} | Başarılı: ${batchProgress.successful} | Hatalı: ${batchProgress.failed}`}
            </Typography>
          </Box>
        )}
      </Box>
      <Snackbar
        open={successSnackbar}
        autoHideDuration={4000}
        onClose={() => setSuccessSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="success"
          onClose={() => setSuccessSnackbar(false)}
          sx={{ borderRadius: 2 }}
        >
          Tüm pinler başarıyla oluşturuldu!
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default BulkPinCreationPage;
